module.exports = __webpack_public_path__ + "static/media/netlify.26581624.svg";